import bi from './bi';

const modules = {
    bi,
};

export default function createDirectives(vue) {
    for (const k in modules) {
        if (Object.hasOwn(modules, k)) {
            vue.directive(k, modules[k]);
        }
    }
}
